export default __webpack_public_path__ + "static/media/ticket1024.139cd756.png";